import { graphql } from '@graphql/gql';

export const ACCEPT_APPOINTMENT = graphql(`
  mutation ACCEPT_APPOINTMENT($id: ID!, $source: String) {
    acceptAppointment(id: $id, source: $source) {
      id
      name
      description
      start
      end
      status
      enrolled
      included
      virtual
      virtualLink
      openForRegistration
      featured
      category {
        id
        name
      }
      location {
        id
        name
        code
      }
      exhibitors {
        id
        name
        description
        profileLogoUrl
        featured
      }
      webcast {
        id
        eventId
        sessionId
        format
        title
        sourceId
        provider
        meetingId
        details
        playerType
        type
        simulatedLive
        onDemandVideo
        player {
          videoId
          videoUrl
          password
          playerTypeProvider
          duration
          simuliveOffset
          stream {
            id
            status
          }
        }
        links {
          recording {
            href
          }
        }
      }
      type
      openForAttendeeHub
      participants {
        id
        firstName
        lastName
      }
      appointmentStatus
      parentLocationDisplayName
      locationDisplayName
      requesters {
        firstName
        lastName
        status
        attendance
        inviteeStub
        title
        company
        profileImageUrl
      }
      requestees {
        firstName
        lastName
        status
        attendance
        inviteeStub
        title
        company
        profileImageUrl
      }
      apptType {
        category
        timeSlotType
      }
      conflict
      availableAttendeeActions {
        accept
        decline
      }
      impactedAgendaItems {
        id
      }
    }
  }
`);
